// import axios from 'axios';
import { getField, updateField } from 'vuex-map-fields';

// const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  namespaced: true,
  state: {
    myPlates: {},
    states: [
      { value: '0', text: 'Todos' },
      { value: 'AC', text: 'AC' },
      { value: 'AL', text: 'AL' },
      { value: 'AP', text: 'AP' },
      { value: 'AM', text: 'AM' },
      { value: 'BA', text: 'BA' },
      { value: 'CE', text: 'CE' },
      { value: 'DF', text: 'DF' },
      { value: 'ES', text: 'ES' },
      { value: 'GO', text: 'GO' },
      { value: 'MA', text: 'MA' },
      { value: 'MT', text: 'MT' },
      { value: 'MS', text: 'MS' },
      { value: 'MG', text: 'MG' },
      { value: 'PA', text: 'PA' },
      { value: 'PB', text: 'PB' },
      { value: 'PR', text: 'PR' },
      { value: 'PE', text: 'PE' },
      { value: 'PI', text: 'PI' },
      { value: 'RJ', text: 'RJ' },
      { value: 'RN', text: 'RN' },
      { value: 'RS', text: 'RS' },
      { value: 'RO', text: 'RO' },
      { value: 'RR', text: 'RR' },
      { value: 'SC', text: 'SC' },
      { value: 'SP', text: 'SP' },
      { value: 'SE', text: 'SE' },
      { value: 'TO', text: 'TO' },
    ],
  },

  mutations: {
    updateField,
  },

  actions: {
    // eslint-disable-next-line
    async getPlates({ commit }, obj) {
      window.console.log('getPlates');
      // await axios.get(
      //   `${url}/add-dealers/${obj.userId}`,
      //   { dealers: obj.dealersIds },
      //   { headers: { 'x-access-token': obj.token } },
      // );
    },

    // eslint-disable-next-line
    async download({ commit }, obj) {
      window.console.log('download');
    },
  },

  getters: { getField },
};
